import { useEffect, useState, useCallback } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { WarningCircle, Clock } from "@phosphor-icons/react";

export default function MaintenanceOverlay({ children }) {
  const { user } = useAuth();
  const [maintenance, setMaintenance] = useState({ enabled: false, message: "", scheduled_at: null });
  const [checked, setChecked] = useState(false);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/maintenance-status");
      setMaintenance(data);
    } catch {
      setMaintenance({ enabled: false, message: "", scheduled_at: null });
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    check();
    const interval = setInterval(check, 60000);
    return () => clearInterval(interval);
  }, [check]);

  if (!checked) return children;

  if (maintenance.enabled && user && user?.role !== "admin") {
    const scheduledLabel = maintenance.scheduled_at
      ? new Date(maintenance.scheduled_at).toLocaleString("en-IN", {
          day: "numeric", month: "short", year: "numeric",
          hour: "2-digit", minute: "2-digit",
        })
      : null;

    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-6">
        <div className="max-w-md text-center">
          <div className="w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
            <WarningCircle size={40} className="text-primary" weight="duotone" />
          </div>
          <h1 className="font-display font-bold text-2xl text-foreground mb-3">Under Maintenance</h1>
          <p className="text-muted-foreground leading-relaxed mb-6">
            {maintenance.message || "The platform is currently under maintenance. Please check back later."}
          </p>
          {scheduledLabel && (
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-muted text-sm text-muted-foreground">
              <Clock size={15} />
              Expected back {scheduledLabel}
            </div>
          )}
        </div>
      </div>
    );
  }

  return children;
}
